import styled from "styled-components"
import Tag from "@irati/ui/src/Tag"

const StyledTag = styled(Tag)`
  text-align: left;
  margin-right: 0;
`

export default StyledTag
